import '@/plugins/carousel'
import { initGallery } from '@/components/calls/image-gallery'
import './search-articles'

initGallery()
